// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1bWbd","productName":"Table_productName__3M1kj"};